import type { Station } from "../Components/Track/StationTrack";
import { SERVICES } from "./services";

/** Service choices on the Contact form; picked ones are appended to the message. */
export const SERVICE_CHOICES: string[] = [...SERVICES.map((s) => s.name), "Not sure yet"];

/** "What happens next" track on the Contact page. No promises about price or turnaround. */
export const NEXT_STEPS: Station[] = [
  { title: "We read your message", text: "A real person on our team reviews what you’re working on." },
  { title: "We talk it through", text: "A call to understand your goals, users and constraints." },
  {
    title: "You get a clear plan",
    text: "Scope, approach and next steps — so you know exactly what you’re getting.",
  },
];
